<template>
    <main-content>
        <div class="shadow-sm rounded p-4 bg-white">
            <form @submit.prevent="changeSettings()" id="submit_form">
                <div class="row">
                    <div class="col-12 col-md-6 my-2">
                        <label for="wallet_title" v-text="$t('label.title')"></label>
                        <input class="form-control"
                               id="wallet_title"
                               name="wallet_title"
                               v-model="form_data.wallet_title"
                        >
                    </div>

                    <div class="col-12 col-md-6 my-2">
                        <label for="status" v-text="$t('label.status')"></label>
                        <select class="form-control" id="status" name="status" v-model="form_data.status">
                            <option v-text="walletStatusStr.get(walletStatus.ACTIVE)"
                                    :value="walletStatus.ACTIVE">
                            </option>
                            <option v-text="walletStatusStr.get(walletStatus.INACTIVE)"
                                    :value="walletStatus.INACTIVE">
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-6 my-2">
                        <label for="settlement_period_limit" v-text="$t('label.settlement_period_limit')"></label>
                        <select class="form-control" id="settlement_period_limit" name="settlement_period_limit" v-model="form_data.settlement_period_limit">
                            <option v-text="walletSettlementPeriodLimitStr.get(walletSettlementPeriodLimit.STANDARD)"
                                    selected
                                    :value="walletSettlementPeriodLimit.STANDARD">
                            </option>
                            <option v-text="walletSettlementPeriodLimitStr.get(walletSettlementPeriodLimit.LESS_LIMIT)"
                                    :value="walletSettlementPeriodLimit.LESS_LIMIT">
                            </option>
                            <option v-text="walletSettlementPeriodLimitStr.get(walletSettlementPeriodLimit.NO_LIMIT)"
                                    :value="walletSettlementPeriodLimit.NO_LIMIT">
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-6 my-2">
                        <label for="blocked_amount" v-text="$t('label.blocked_amount')"></label>
                        <input
                                id="blocked_amount"
                                name="blocked_amount"
                                class="form-control"
                                v-model="blocked_amount.amount"
                        >
                    </div>

                    <div class="col-12 col-md-6 my-2">
                        <label for="settlement_provider_variant" v-text="$t('wallets.label.settlement_provider_variant')"></label>
                        <select class="form-control"
                                id="settlement_provider_variant"
                                name="settlement_provider_variant"
                                v-model="settlement_provider_variant"
                        >
                            <option v-for="(value, name ,index) in SettlementProviderVariant" :key="index" v-text="SettlementProviderVariantStr.get(value)"
                                    :value="value"
                            >
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-6 my-2">
                        <label for="lock_status" v-text="$t('wallets.label.lock_status')"></label>
                        <select class="form-control"
                                id="lock_status"
                                name="lock_status"
                                v-model="form_data.lock_status"
                        >
                            <option v-text="WalletLockStatusStr.get(WalletLockStatus.UNLOCK)"
                                    :value="WalletLockStatus.UNLOCK"
                            >
                            </option>
                            <option v-text="WalletLockStatusStr.get(WalletLockStatus.LOCK)"
                                    :value="WalletLockStatus.LOCK"
                            >
                            </option>
                            <option v-text="WalletLockStatusStr.get(WalletLockStatus.PERMANENT_LOCK)"
                                    :value="WalletLockStatus.PERMANENT_LOCK"
                            >
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-6 my-2">
                        <label for="settlement_limit_status" v-text="$t('wallets.label.settlement_limit_status')"></label>
                        <select class="form-control"
                                id="settlement_limit_status"
                                name="settlement_limit_status"
                                v-model="form_data.settlement_limit_status"
                        >
                            <option
                                    :value="true"
                                    :selected="form_data.settlement_limit_status"
                                    v-text="$t('label.active')"
                            >
                            </option>
                            <option
                                    :value="false"
                                    :selected="!form_data.settlement_limit_status"
                                    v-text="$t('label.inactive')"
                            >
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-6 my-2">
                        <label for="settlement_limit" v-text="$t('wallets.label.settlement_limit')"></label>
                        <input
                            :disabled="!form_data.settlement_limit_status"
                            id="settlement_limit"
                            name="settlement_limit"
                            class="form-control"
                            v-model="form_data.settlement_limit"
                        >
                    </div>
                </div>

                <div class="line-divider my-3"></div>

                <div class="row">
                    <div class="col-12 col-md-6 my-2">
                        <label for="wage_type" v-text="$t('label.paystar_wage')"></label>
                        <select class="form-control" id="wage_type" name="wage_type" v-model="form_data.wage_type">
                            <option v-for="(item, index) in walletWageType"
                                    :key="index"
                                    v-text="walletWageTypeStr.get(item)"
                                    :value="item"
                            >
                            </option>
                        </select>
                    </div>

                    <div v-if="form_data.wage_type === walletWageType.LIMITED_PERCENT
                                || form_data.wage_type === walletWageType.PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="wage_percent" v-text="$t('label.wage_percent')"></label>
                        <input class="form-control"
                               dir="ltr"
                               id="wage_percent"
                               name="wage_percent"
                               v-model="form_data.wage_percent"
                        >
                    </div>

                    <div v-if="form_data.wage_type === walletWageType.CONSTANT
                                || form_data.wage_type === walletWageType.LIMITED_PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="wage_amount"
                               v-text="form_data.wage_type === walletWageType.LIMITED_PERCENT ?
                                        $t('label.max_wage') : $t('label.wage_amount')"
                        >
                        </label>
                        <input class="form-control"
                               dir="ltr"
                               id="wage_amount"
                               name="wage_amount"
                               v-model="form_data.wage_amount"
                        >
                    </div>

                    <div v-if="form_data.wage_type === walletWageType.LIMITED_PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="min_wage_amount" v-text="$t('label.min_wage_amount')"></label>
                        <input class="form-control"
                               dir="ltr"
                               id="min_wage_amount"
                               name="min_wage_amount"
                               v-model="form_data.min_wage_amount"
                        >
                    </div>
                </div>
                <div class="line-divider my-3"></div>

                <div class="row">
                    <div class="col-12 col-md-6 my-2">
                        <label for="wage_type" v-text="$t('label.refund_wage')"></label>
                        <select class="form-control" id="wage_type" name="wage_type" v-model="form_data.refund_wage_type">
                            <option v-for="(item, index) in walletWageType"
                                    :key="index"
                                    v-text="walletWageTypeStr.get(item)"
                                    :value="item"
                            >
                            </option>
                        </select>
                    </div>

                    <div v-if="form_data.refund_wage_type === walletWageType.LIMITED_PERCENT
                                || form_data.refund_wage_type === walletWageType.PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="wage_percent" v-text="$t('label.wage_percent')"></label>
                        <input class="form-control"
                               dir="ltr"
                               id="wage_percent"
                               name="wage_percent"
                               v-model="form_data.refund_wage_percent"
                        >
                    </div>

                    <div v-if="form_data.refund_wage_type === walletWageType.CONSTANT
                                || form_data.refund_wage_type === walletWageType.LIMITED_PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="wage_amount"
                               v-text="form_data.refund_wage_type === walletWageType.LIMITED_PERCENT ?
                                        $t('label.max_wage') : $t('label.wage_amount')"
                        >
                        </label>
                        <input class="form-control"
                               dir="ltr"
                               id="wage_amount"
                               name="wage_amount"
                               v-model="form_data.refund_wage_amount"
                        >
                    </div>

                    <div v-if="form_data.refund_wage_type === walletWageType.LIMITED_PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="min_wage_amount" v-text="$t('label.min_wage_amount')"></label>
                        <input class="form-control"
                               dir="ltr"
                               id="min_wage_amount"
                               name="min_wage_amount"
                               v-model="form_data.refund_min_wage_amount"
                        >
                    </div>
                </div>

                <div class="line-divider my-3"></div>

                <div class="row">
                    <div class="col-12 col-md-6 my-2">
                        <label for="paystar_wage_charge_type" v-text="$t('label.paystar_wage_charge')"></label>
                        <select class="form-control" id="paystar_wage_charge_type" name="paystar_wage_charge_type" v-model="form_data.paystar_wage_charge_type">
                            <option v-for="(item, index) in walletWageType"
                                    :key="index"
                                    v-text="walletWageTypeStr.get(item)"
                                    :value="item"
                            >
                            </option>
                        </select>
                    </div>

                    <div v-if="form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT
                                || form_data.paystar_wage_charge_type === walletWageType.PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="paystar_wage_charge_percent" v-text="$t('label.wage_percent')"></label>
                        <input class="form-control"
                               dir="ltr"
                               id="paystar_wage_charge_percent"
                               name="paystar_wage_charge_percent"
                               v-model="form_data.paystar_wage_charge_percent"
                        >
                    </div>

                    <div v-if="form_data.paystar_wage_charge_type === walletWageType.CONSTANT
                                || form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="paystar_wage_charge_amount"
                               v-text="form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT ?
                                        $t('label.max_wage') : $t('label.wage_amount')"
                        >
                        </label>
                        <input class="form-control"
                               dir="ltr"
                               id="paystar_wage_charge_amount"
                               name="paystar_wage_charge_amount"
                               v-model="form_data.paystar_wage_charge_amount"
                        >
                    </div>

                    <div v-if="form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="paystar_min_wage_charge_amount" v-text="$t('label.min_wage_amount')"></label>
                        <input class="form-control"
                               dir="ltr"
                               id="paystar_min_wage_charge_amount"
                               name="paystar_min_wage_charge_amount"
                               v-model="form_data.paystar_min_wage_charge_amount"
                        >
                    </div>
                </div>


                <div v-if="form_data.shareholder_settings" class="line-divider my-3"></div>

                <div v-if="form_data.shareholder_settings" class="row">
                  <div class="col-12 col-md-6">
                    <kt-form-group class="my-1">
                      <label for="shareholders">
                        {{ $t('label.shareholders') }}
                      </label>
                      <select
                          id="shareholder_levels"
                          class="form-control"
                          name="shareholder_levels"
                          v-model="form_data.shareholder_settings.status"
                      >
                        <option :value="false">براساس تنظیمات عمومی</option>
                        <option :value="true">براساس تنظیمات اختصاصی</option>
                      </select>
                    </kt-form-group>
                  </div>

                  <div v-if="form_data.shareholder_settings.status == 1" class="col-12 my-4">
                    <button @click.prevent="addLevel" class="btn-sm btn-success">افزودن سطح</button>
                  </div>
                  <div v-for="(level, key) in shareholder_levels" :key="key" class="col-12">
                    <div v-if="form_data.shareholder_settings.status == 1">
                      <div class="d-flex align-items-center w-100">
                        <label> {{ 'سطح ' + (key + 1) +  ':'}} </label>
                        <div class="col-sm-4 d-flex align-items-center">
                          <label class="text-nowrap mr-2" :for="`settlement_limit_${key}`">
                            {{ $t('label.settlement_limit') }}
                          </label>
                          <input
                              class="form-control"
                              dir="ltr"
                              :id="`settlement_limit_${key}`"
                              :name="`settlement_limit_${key}`"
                              v-model="level.settlement_limit"
                          >
                        </div>
                        <div class="col-sm-2 custom-switch custom-control">
                          <input
                              type="checkbox"
                              class="custom-control-input"
                              :id="`iban_national_id_matching_${key}`"
                              :name="`iban_national_id_matching_${key}`"
                              v-model="level.iban_national_id_matching"
                          >
                          <label class="custom-control-label" :for="`iban_national_id_matching_${key}`">{{ $t('label.iban_national_id_matching') }}</label>
                        </div>
                        <div class="col-sm-2 custom-switch custom-control">
                          <input
                              type="checkbox"
                              class="custom-control-input"
                              :id="`phone_national_id_matching_${key}`"
                              :name="`phone_national_id_matching_${key}`"
                              v-model="level.phone_national_id_matching"
                          >
                          <label class="custom-control-label" :for="`phone_national_id_matching_${key}`">{{ $t('label.phone_national_id_matching') }}</label>
                        </div>
                        <div class="col-sm-2 custom-switch custom-control">
                          <input
                              type="checkbox"
                              class="custom-control-input"
                              :id="`otp_authentication_condition_${key}`"
                              :name="`otp_authentication_condition_${key}`"
                              v-model="level.otp_authentication_condition"
                          >
                          <label class="custom-control-label" :for="`otp_authentication_condition_${key}`">{{ $t('label.otp_authentication_condition') }}</label>
                        </div>
                        <button @click.prevent="deleteLevel(key)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                      <div class="line-divider my-3 w-75 mx-auto"></div>
                    </div>
                  </div>
                </div>

                <div class="line-divider my-3"></div>

                <div class="col-12 col-md-6 my-2">
                  <kt-form-group class="my-4">
                    <label for="charge_period">
                      {{ $t('label.settlement_period') }}
                    </label>
                    <select id="charge_period"
                            class="form-control"
                            name="charge_period"
                            v-model="form_data.charge_period"
                    >
                      <option v-for="(item, index) in walletChargePeriod"
                              :key="index"
                              v-text="walletChargePeriodStr.get(item)"
                              :value="item"
                      >
                      </option>
                    </select>
                  </kt-form-group>
                </div>

                <div class="line-divider my-3"></div>

                <div class="row">
                    <div class="col-12 my-2">
                        <i class="fas fa-exclamation-triangle text-danger"></i>
                        <span style="font-size: .9rem" class="px-2" v-text="$t('label.changes_need_settlement_permission')"></span>
                    </div>

                    <div class="col-12 col-md-6 my-2">
                        <label for="instant_settlement_status" v-text="$t('label.instant_settlement_status')"></label>
                        <select class="form-control"
                                id="instant_settlement_status"
                                name="instant_settlement_status"
                                v-model="form_data.instant_settlement_status"
                        >
                            <option v-text="instantSettlementStatusStr.get(instantSettlementStatus.ACTIVE)"
                                    :value="instantSettlementStatus.ACTIVE">
                            </option>
                            <option v-text="instantSettlementStatusStr.get(instantSettlementStatus.INACTIVE)"
                                    :value="instantSettlementStatus.INACTIVE">
                            </option>
                        </select>
                    </div>

                    <div class="col-12">&nbsp;</div>

                    <div class="col-12 col-md-6 my-2">
                        <label for="upcoming_settlement_setting_status" v-text="$t('wallets.label.upcoming_settlement_setting_status')"></label>
                        <select class="form-control"
                                id="upcoming_settlement_setting_status"
                                name="upcoming_settlement_setting_status"
                                v-model="upcoming_settlement_setting_status"
                        >
                            <option v-text="walletSettingStatusStr.get(walletSettingStatus.ENABLE)"
                                    :value="walletSettingStatus.ENABLE"
                            >
                            </option>
                            <option v-text="walletSettingStatusStr.get(walletSettingStatus.DISABLE)"
                                    :value="walletSettingStatus.DISABLE"
                            >
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-6 my-2"
                         v-if="upcoming_settlement_setting_status === walletSettingStatus.ENABLE">
                        <label for="upcoming_settlement_amount" v-text="$t('label.upcoming_settlement_amount')"></label>
                        <input
                            id="upcoming_settlement_amount"
                            name="upcoming_settlement_amount"
                            class="form-control"
                            v-model="upcoming_settlement_amount"
                        >
                    </div>

                    <div class="col-12 col-md-6 my-2"
                         v-if="upcoming_settlement_setting_status === walletSettingStatus.ENABLE"
                    >
                        <label for="upcoming_settlement_wage_type" v-text="$t('label.upcoming_settlement_wage_type')"></label>
                        <select class="form-control"
                                id="upcoming_settlement_wage_type"
                                name="upcoming_settlement_wage_type"
                                v-model="upcoming_settlement_wage_type"
                        >
                            <option v-text="walletWageTypeStr.get(walletWageType.SAME_AS_GLOBAL)"
                                    :value="walletWageType.SAME_AS_GLOBAL"
                            >
                            </option>
                            <option v-text="walletWageTypeStr.get(walletWageType.LIMITED_PERCENT)"
                                    :value="walletWageType.LIMITED_PERCENT"
                            >
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-6 my-2"
                         v-if="upcoming_settlement_setting_status === walletSettingStatus.ENABLE
                            && upcoming_settlement_wage_type === walletWageType.LIMITED_PERCENT">
                        <label for="upcoming_settlement_wage_percent" v-text="$t('label.wage_percent')"></label>
                        <input
                            id="upcoming_settlement_wage_percent"
                            name="upcoming_settlement_wage_percent"
                            class="form-control"
                            v-model="upcoming_settlement_wage_percent"
                        >
                    </div>

                    <div class="col-12 col-md-6 my-2"
                         v-if="upcoming_settlement_setting_status === walletSettingStatus.ENABLE
                            && upcoming_settlement_wage_type === walletWageType.LIMITED_PERCENT">
                        <label for="upcoming_settlement_wage_max" v-text="$t('label.max_wage')"></label>
                        <input
                            id="upcoming_settlement_wage_max"
                            name="upcoming_settlement_wage_max"
                            class="form-control"
                            v-model="upcoming_settlement_wage_max"
                        >
                    </div>

                    <div class="col-12 col-md-6 my-2"
                         v-if="upcoming_settlement_setting_status === walletSettingStatus.ENABLE
                            && upcoming_settlement_wage_type === walletWageType.LIMITED_PERCENT">
                        <label for="upcoming_settlement_wage_min" v-text="$t('label.min_wage_amount')"></label>
                        <input
                            id="upcoming_settlement_wage_min"
                            name="upcoming_settlement_wage_min"
                            class="form-control"
                            v-model="upcoming_settlement_wage_min"
                        >
                    </div>

                    <div v-if="should_show_verify_code_field"
                         class="col-12 col-md-6 my-2"
                    >
                        <label for="verify_code" v-text="$t('label.verify_code')"></label>
                        <input class="form-control"
                               dir="ltr"
                               id="verify_code"
                               name="verify_code"
                               v-model="form_data.verify_code"
                        >
                    </div>

                    <div class="col-12 my-2">
                        <button class="btn btn-primary mx-2"
                                type="button"
                                v-text="$t('label.get_verify_code_for_instant_settlement')"
                                @click="getVerifyCode()"
                        ></button>
                    </div>
                </div>

                <div v-if="!fetchStarshop" class="line-divider my-3"></div>
                <div v-if="!fetchStarshop" class="row">
                    <div class="col-12 col-md-4 my-2">
                        <label for="internal_settlement_limit_status" v-text="$t('wallets.label.internal_settlement_limit_status')"></label>
                        <select class="form-control"
                                id="internal_settlement_limit_status"
                                name="internal_settlement_limit_status"
                                v-model="form_data.internal_settlement_limit_status"
                        >
                            <option
                                :value="true"
                                :selected="form_data.internal_settlement_limit_status"
                                v-text="$t('label.active')"
                            >
                            </option>
                            <option
                                :value="false"
                                :selected="!form_data.internal_settlement_limit_status"
                                v-text="$t('label.inactive')"
                            >
                            </option>
                        </select>
                    </div>
                    <div v-if="form_data.internal_settlement_limit_status" class="col-12 col-md-6 my-2">
                        <label for="wallet_title" v-text="$t('wallets.label.internal_settlement_limit_amount')"></label>
                        <input class="form-control"
                               id="internal_settlement_limit_amount"
                               name="internal_settlement_limit_amount"
                               v-model="form_data.internal_settlement_limit_amount"
                        >
                    </div>
                </div>
                <div class="line-divider my-3"></div>

                <div class="row">
                    <div class="col-12 mt-4">
                        <button class="btn btn-success" type="submit" :disabled="!wallet_data_fetched_successfully" v-text="form_meta_data.submit_btn_text"></button>
                        <button v-if="form_data.total_amount == 0"
                                class="btn btn-danger mx-2"
                                type="button"
                                @click="deleteWallet()"
                                v-text="$t('label.delete_wallet')"
                        ></button>
                    </div>
                </div>
            </form>
        </div>
    </main-content>
</template>

<script>
    import mainContent from "@/components/main-content";
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {walletStatus, walletStatusStr} from "@/constants/walletStatus";
    import {authService, walletService} from "@/common/api.service";
    import {walletWageType, walletWageTypeStr} from "@/constants/WalletWageType";
    import {instantSettlementStatus, instantSettlementStatusStr} from "@/constants/instantSettlementStatus";
    import {SettlementProviderVariant, SettlementProviderVariantStr} from "@/constants/SettlementProviderVariant";
    import {WalletLockStatus, WalletLockStatusStr} from "@/constants/WalletLockStatus";
    import {walletSettingStatus, walletSettingStatusStr} from "@/constants/walletSettingStatus";
    import {walletSettlementPeriodLimit, walletSettlementPeriodLimitStr} from "@/constants/walletSettlementPeriodLimit";
    import {walletChargePeriod, walletChargePeriodStr} from "@/constants/walletChargePeriod";

    export default {
        components: {
            mainContent,
        },
        data() {
            return {
                walletChargePeriod,
                walletChargePeriodStr,
                walletSettingStatusStr,
                walletSettingStatus,
                walletSettlementPeriodLimit,
                walletSettlementPeriodLimitStr,
                walletWageType,
                walletWageTypeStr,
                SettlementProviderVariant,
                SettlementProviderVariantStr,
                WalletLockStatus,
                WalletLockStatusStr,
                walletStatus,
                walletStatusStr,
                instantSettlementStatus,
                instantSettlementStatusStr,
                should_show_verify_code_field: false,
                form_data: {
                    wallet_title: '',
                    status: '',
                    wage_type: 1,
                    wage_percent: 0,
                    wage_amount: 0,
                    min_wage_amount: 0,
                    refund_wage_type: 1,
                    refund_wage_percent: 0,
                    refund_wage_amount: 0,
                    refund_min_wage_amount: 0,
                    instant_settlement_status: 0,
                    verify_code: '',
                    lock_status: WalletLockStatus.UNLOCK,
                    paystar_wage_charge_type: 1,
                    paystar_wage_charge_amount: 0,
                    paystar_wage_charge_percent: 0,
                    min_wage_charge_amount: 0,
                    settlement_period_limit: walletSettlementPeriodLimit.STANDARD,
                    charge_period: walletChargePeriod.DAILY,
                    settlement_limit_status: true,
                    internal_settlement_limit_status: false,
                    internal_settlement_limit_amount: 0,
                    settlement_limit: 1e10,
                },
                shareholder_levels: [],
                blocked_amount: {
                    amount: '',
                },
                settlement_provider_variant: SettlementProviderVariant.BASED_ON_SETTLEMENT_BANK,
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('btn.submit_changes'),
                },
                upcoming_settlement_setting_status: walletSettingStatus.DISABLE,
                upcoming_settlement_amount: 0,
                upcoming_settlement_wage_max: '',
                upcoming_settlement_wage_min: '',
                upcoming_settlement_wage_percent: '',
                upcoming_settlement_wage_type: walletWageType.SAME_AS_GLOBAL,
                wallet_data_fetched_successfully: false,
            };
        },
        computed: {
            slug() {
                return this.$route.params.slug;
            },
            fetchStarshop() {
                return this.slug === 'starshop';
            }

        },
        mounted() {
            let hashid = this.$route.params.hashid;
            const find = this.fetchStarshop
                    ? walletService.findStarShop(hashid)
                    : walletService.find(hashid);

            find.then(res => {
                this.form_data = res.data.data;
                this.wallet_data_fetched_successfully = true;
                $('#blocked_amount').val(res.data.data.blocked_amount);
                this.blocked_amount.amount = res.data.data.blocked_amount;
                this.settlement_provider_variant = res.data.data.settlement_provider_variant;

                this.upcoming_settlement_setting_status = res.data.data.upcoming_settlement.setting_status;
                this.upcoming_settlement_amount = res.data.data.upcoming_settlement.amount;
                this.upcoming_settlement_wage_type = res.data.data.upcoming_settlement.wage_type;
                this.upcoming_settlement_wage_max = res.data.data.upcoming_settlement.wage_max;
                this.upcoming_settlement_wage_min = res.data.data.upcoming_settlement.wage_min;
                this.upcoming_settlement_wage_percent = res.data.data.upcoming_settlement.wage_percent;
                this.shareholder_levels = res.data.data.shareholder_settings.shareholder_levels || [];
            }).catch(err => {
                //
            });
        },
        methods: {
            addLevel() {
              this.shareholder_levels.push({
                  settlement_limit: null,
                  iban_national_id_matching: false,
                  phone_national_id_matching: false,
                  otp_authentication_condition: false,
              })
            },
            deleteLevel(key) {
              this.shareholder_levels.splice(key, 1);
            },
            getVerifyCode() {
                let phone = this.$store.state.user.current_user.phone;

                let verify = {
                    phone,
                };

                authService.sendVerifyWallet(verify).then(res => {
                    this.should_show_verify_code_field = true;
                });
            },
            deleteWallet() {
                let should_delete = confirm(i18n.t('wallets.label.are_you_sure_for_deleting_this_wallet'));

                if (should_delete) {
                    const deleteWallet = this.fetchStarshop
                        ? walletService.adminDeleteStarShopWallet
                        : walletService.adminDeleteWallet;
                    deleteWallet(this.$route.params.hashid).then(res => {
                        this.$router.push(`/wallets/admin/${this.slug}`);
                    });
                }
            },
            changeSettings() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        wallet_title: {
                            required: true,
                        },
                        // status: {
                        //     required: true,
                        // },
                        wage_type: {
                            required: true,
                        },
                        wage_percent: {
                            required: () => {
                                return this.form_data.wage_type === walletWageType.PERCENT
                                    || this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        wage_amount: {
                            required: () => {
                                return this.form_data.wage_type === walletWageType.CONSTANT
                                    || this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        min_wage_amount: {
                            required: () => {
                                return this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        paystar_wage_charge_type: {
                            required: true,
                        },
                        paystar_wage_charge_percent: {
                            required: () => {
                                return this.form_data.paystar_wage_charge_type === walletWageType.PERCENT
                                    || this.form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        paystar_wage_charge_amount: {
                            required: () => {
                                return this.form_data.paystar_wage_charge_type === walletWageType.CONSTANT
                                    || this.form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        paystar_min_wage_charge_amount: {
                            required: () => {
                                return this.form_data.paystar_wage_charge_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        instant_settlement_status: {
                            required: true,
                        },
                        blocked_amount: {
                            required: true,
                        },
                        settlement_provider_variant: {
                            required: true,
                        },
                        lock_status: {
                            required: true,
                        },
                        settlement_period_limit: {
                            required: true,
                        },
                        charge_period: {
                            required: true,
                        },
                        upcoming_settlement_setting_status: {
                            required: true,
                        },                        
                        upcoming_settlement_amount: {
                            required: () => {
                                return this.upcoming_settlement_setting_status === walletSettingStatus.ENABLE;
                            },
                        },
                        upcoming_settlement_wage_type: {
                            required: () => {
                                return this.upcoming_settlement_setting_status === walletSettingStatus.ENABLE;
                            },
                        },
                        upcoming_settlement_wage_max: {
                            required: () => {
                                return this.upcoming_settlement_setting_status === walletSettingStatus.ENABLE && this.upcoming_settlement_wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        upcoming_settlement_wage_min: {
                            required: () => {
                                return this.upcoming_settlement_setting_status === walletSettingStatus.ENABLE && this.upcoming_settlement_wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        upcoming_settlement_wage_percent: {
                            required: () => {
                                return this.upcoming_settlement_setting_status === walletSettingStatus.ENABLE && this.upcoming_settlement_wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                    }
                });
                
                if (! form.valid()) {
                    return;
                }

                // this.form_meta_data.submit_btn_progress = true;
                
                let params = {
                    status: this.form_data.status,
                    wallet_title: this.form_data.wallet_title,
                    wage_type: this.form_data.wage_type,
                    wage_percent: this.form_data.wage_percent,
                    wage_amount: this.form_data.wage_amount,
                    refund_wage_type: this.form_data.refund_wage_type,
                    refund_wage_percent: this.form_data.refund_wage_percent,
                    refund_wage_amount: this.form_data.refund_wage_amount,
                    settlement_period_limit: this.form_data.settlement_period_limit,

                    paystar_wage_charge_type: this.form_data.paystar_wage_charge_type,
                    paystar_wage_charge_percent: this.form_data.paystar_wage_charge_percent,
                    paystar_wage_charge_amount: this.form_data.paystar_wage_charge_amount,
                    paystar_min_wage_charge_amount: this.form_data.paystar_min_wage_charge_amount,

                    min_wage_amount: this.form_data.min_wage_amount,
                    refund_min_wage_amount: this.form_data.refund_min_wage_amount,
                    instant_settlement_status: this.form_data.instant_settlement_status,
                    code: this.form_data.verify_code,
                    blocked_amount: this.blocked_amount.amount,
                    settlement_provider_variant: this.settlement_provider_variant,
                    lock_status: this.form_data.lock_status,
                    charge_period: this.form_data.charge_period,
                    settlement_limit_status: this.form_data.settlement_limit_status,
                    settlement_limit: this.form_data.settlement_limit,

                    upcoming_settlement_setting_status: this.upcoming_settlement_setting_status,
                    upcoming_settlement_amount: this.upcoming_settlement_amount,
                    upcoming_settlement_wage_type: this.upcoming_settlement_wage_type,
                    upcoming_settlement_wage_max: this.upcoming_settlement_wage_max,
                    upcoming_settlement_wage_min: this.upcoming_settlement_wage_min,
                    upcoming_settlement_wage_percent: this.upcoming_settlement_wage_percent,
                    // shareholder_setting_status:  Boolean(this.form_data.shareholder_settings.status),
                };                

                // if (!this.fetchStarshop) {
                //     params.internal_settlement_limit_status = this.form_data.internal_settlement_limit_status;
                //     params.internal_settlement_limit_amount = this.form_data.internal_settlement_limit_amount;
                // }

                // if (this.form_data.shareholder_settings.status == 1) {
                //     params.shareholder_levels = this.shareholder_levels.map(function (item, index) {
                //       return {
                //         id: (index + 1),
                //         name: 'سطح ' + (index + 1),
                //         settlement_limit: item.settlement_limit,
                //         iban_national_id_matching: item.iban_national_id_matching,
                //         phone_national_id_matching: item.phone_national_id_matching,
                //         otp_authentication_condition: item.otp_authentication_condition,
                //       }
                //     })
                // }
                
                const changeSettings = this.fetchStarshop
                    ? walletService.changeStarShopSettingsByAdmin
                    : walletService.changeSettingsByAdmin;

                changeSettings(params, this.$route.params.hashid).then(res => {
                      this.$router.push(`/wallets/admin/${this.slug}`);
                  }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);
                    window.scrollTo({top: 0, behavior: 'smooth'});
                      if (response.data) {
                          form.validate().showErrors(response.data.data);
                      }
                  }).finally(() => {
                      this.form_meta_data.submit_btn_progress = false;
                  });
              },
        },
    }
</script>
